
import * as actions from './actionsTypes';
import errorManage from '../../errorManage';

import surveyResultsServices from './surveyResults.services';

export const getSurveyResults = (params) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_RESULTS_REQUEST, payload: true });
  try {
    const response = await surveyResultsServices.getSurveyResults(params);
    dispatch({ type: actions.FETCH_SURVEY_RESULTS_SUCCESS, payload: response.data });
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_RESULTS_FAILURE);
  }finally{
    dispatch({ type: actions.FETCH_SURVEY_RESULTS_REQUEST, payload: false });
  }
}